import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadRoleListFailed, loadRoleListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadRoleList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/user/roles`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      const body = Array.isArray(data.data) ? data.data : [];
      yield put(loadRoleListSuccessful(body));
      yield call(resolveActionPromise(action, body));
    } else {
      yield put(loadRoleListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadRoleListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
